import React from 'react';
import './form-label.scss';

export function FormLabel(props: {
  label: string;
  children: React.ReactFragment;
  className?: string;
}) {
  return (
    <div className={`FormLabel ${props.className || ''}`}>
      <p className="label-text">{props.label}</p>
      {props.children}
    </div>
  );
}
